"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVoucherType = exports.ECartTypeId = exports.ECurrency = exports.ELanguage = void 0;
var ELanguage;
(function (ELanguage) {
    ELanguage["DE"] = "de";
    ELanguage["EN"] = "en";
    ELanguage["FR"] = "fr";
    ELanguage["IT"] = "it";
    ELanguage["ES"] = "es";
    ELanguage["NL"] = "nl";
    ELanguage["PL"] = "pl";
    ELanguage["CS"] = "cs";
    ELanguage["SK"] = "sk";
    ELanguage["PT"] = "pt";
    ELanguage["HU"] = "hu";
})(ELanguage = exports.ELanguage || (exports.ELanguage = {}));
var ECurrency;
(function (ECurrency) {
    ECurrency["EUR"] = "eur";
    ECurrency["CHF"] = "chf";
    ECurrency["SEK"] = "sek";
    ECurrency["DKK"] = "dkk";
    ECurrency["GBP"] = "gbp";
    ECurrency["PLN"] = "pln";
    ECurrency["CZK"] = "czk";
    ECurrency["HUF"] = "huf";
    ECurrency["RSD"] = "rsd";
    ECurrency["HRK"] = "hrk";
    ECurrency["MXN"] = "mxn";
})(ECurrency = exports.ECurrency || (exports.ECurrency = {}));
var ECartTypeId;
(function (ECartTypeId) {
    ECartTypeId[ECartTypeId["PERSONAL_USE"] = 1] = "PERSONAL_USE";
    ECartTypeId[ECartTypeId["CUSTOMER"] = 2] = "CUSTOMER";
    ECartTypeId[ECartTypeId["PARTNER_APPLICATION"] = 4] = "PARTNER_APPLICATION";
})(ECartTypeId = exports.ECartTypeId || (exports.ECartTypeId = {}));
var EVoucherType;
(function (EVoucherType) {
    EVoucherType["ARTICLE"] = "article";
    EVoucherType["CASH"] = "cash";
    EVoucherType["DISCOUNT"] = "discount";
})(EVoucherType = exports.EVoucherType || (exports.EVoucherType = {}));
//# sourceMappingURL=index.enum.js.map